import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=769b27e5&scoped=true&"
import script from "./ClientInfo.vue?vue&type=script&lang=ts&"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&id=769b27e5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b27e5",
  null
  
)

export default component.exports